import { Provider } from 'react-redux';
import store from '../../../store';
import NotificationsTrigger from './';

export default function () {
    return (
        <Provider store={store}>
            <NotificationsTrigger />
        </Provider>
    );
}
